import { render, staticRenderFns } from "./UserFormMDP.vue?vue&type=template&id=1347c0b6&scoped=true"
import script from "./UserFormMDP.vue?vue&type=script&lang=js"
export * from "./UserFormMDP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1347c0b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1347c0b6')) {
      api.createRecord('1347c0b6', component.options)
    } else {
      api.reload('1347c0b6', component.options)
    }
    module.hot.accept("./UserFormMDP.vue?vue&type=template&id=1347c0b6&scoped=true", function () {
      api.rerender('1347c0b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user/UserFormMDP.vue"
export default component.exports